import { GoogleAuthProvider, getAuth } from "firebase/auth";
import FirebaseHelper from "./FirebaseHelper";

export const auth = getAuth(FirebaseHelper);
export const googleProvider = new GoogleAuthProvider();
